import store from "@/store";

export default async (to, from, next) => {
  if (store.getters["auth/role"] !== "admin") {
    return next(from.path);
  }

  return next();
};
